export function Wordmark({ size = "md", tagline = true, testId = "brand-wordmark" }) {
  const big = size === "lg";
  return (
    <div className={`leading-none ${big ? "text-center" : ""}`} data-testid={testId}>
      <div className={`font-brand wordmark ${big ? "text-6xl sm:text-7xl lg:text-8xl" : size === "sm" ? "text-xl" : "text-2xl"}`}>Khumgetme</div>
      <div className={`font-display chrome font-bold tracking-[0.35em] ${big ? "text-2xl sm:text-3xl mt-1" : "text-[10px] mt-0.5"}`}>MEDIA</div>
      {tagline && <div className={`font-display text-amber-300/80 tracking-[0.3em] ${big ? "text-xs sm:text-sm mt-5" : "text-[8px] mt-1"}`}>PRODUCTION STUDIO</div>}
    </div>
  );
}

export function TaglineBar() {
  return (
    <div className="inline-flex items-center gap-3 sm:gap-5 px-5 py-2 border-y border-amber-500/30 bg-black/40 font-display text-[11px] sm:text-xs tracking-[0.35em] text-slate-200" data-testid="brand-tagline">
      {["WRITE", "EDIT", "PUBLISH"].map((w, i) => <span key={w} className="flex items-center gap-3 sm:gap-5">{i > 0 && <span className="text-amber-400">◆</span>}{w}</span>)}
    </div>
  );
}
